// extracted by mini-css-extract-plugin
export var Logo = "s_J";
export var angleSvg = "s_L";
export var aniBgLoading = "s_f";
export var aniSpin = "s_d";
export var isInverse = "s_M";
export var rightSvg = "s_K";